import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { subCategoryService } from "@/services/api/cresivoxServer";

import { iSubCategory,REDUCER_NAME} from "./Types";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const addSubCategory = createAsyncThunk<
iGenericResponse<any | null> | null,
{
    categoryId?: string;
    name: string;
    // display_type: string;
    category: string | null;
    description: string;
	image:string |File;
  },
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("addSubCategory"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (payload, {rejectWithValue}) => {
	try {
		const response = await subCategoryService.addSubCategory(payload);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								orders: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

  export const getSubCatgeoryList = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
	  rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("subCategoryList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
	  try {
		  const response = await subCategoryService.getSubCategoryList();
		  if (response) {
			  const {httpStatusCode, data, message} = response;

			  switch (httpStatusCode) {
				  case httpStatusCodes.SUCCESS_OK: {
					  if (data && data.data) {
						  return {
							  httpStatusCode,
							  data: data.data,
							  message,
						  };
					  } else {
						  return rejectWithValue({
							  httpStatusCode,
							  message,
						  });
					  }
				  }
				  default: {
					  return rejectWithValue({
						  httpStatusCode,
						  message,
					  });
				  }
			  }
		  } else {
			  return rejectWithValue({
				  message: "No response received",
			  });
		  }
	  } catch (error) {
		  return rejectWithValue({
			  message: "Something went wrong",
		  });
	  }
  },
);

export const getSubCategoryById = createAsyncThunk<
iGenericResponse<any | null> | null,
{categoryId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("getSubCategoryById"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (arg, {rejectWithValue}) => {
	try {
		const response = await subCategoryService.getSubCategoryById(arg);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const updateSubCategory = createAsyncThunk<
iGenericResponse<any | null> | null,
{
    categoryId: string;
    name: string;
    display_type: string;
    category: string | null;
    description: string;
	slug: string;
	image:string|File;
  },
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateSubCategory"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (payload, {rejectWithValue}) => {
	try {
		const response = await subCategoryService.updateSubCategory(payload);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const deleteSubCategory = createAsyncThunk<
iGenericResponse<any | null> | null,
{categoryIds:string[]},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("deleteSubCategory"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (arg, {rejectWithValue}) => {
	try {
		const response = await subCategoryService.deleteSubCategory({ categoryIds: arg.categoryIds });;
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


